import React from 'react';
import Popup from "reactjs-popup";
import {useSelector} from "react-redux";

import UEmployeeInfo from "../../../common/components/UEmployeeInfo";

const MembersFullNameList = React.memo(({members, size}) => {

    const _USERS = useSelector(e => e?.ats?.userObj || {});

    return (
        <div className="u_flex-align">
            {members?.length > 0 ?
                <div className="u_flex-align u_flex-shrink">
                    <UEmployeeInfo
                        size={size ? size : 24}
                        showName={false}
                        employee={_USERS[members[0]]}
                        isSkeleton={!_USERS[members[0]]}
                    />
                    <span className="u_employee-info__name u_pl-10 u_task-darkname u_small-font">{_USERS[members[0]]?.name}</span>
                </div>
                : '-'
            }
            {members?.length > 1 &&
                <Popup
                    trigger={open => (
                        <span className="u_table-list-total u_cp">
                            {members?.length - 1}+
                        </span>
                    )}
                    className="u_tooltip u_tooltip_more u_tooltip-zIndex"
                    arrow={'center center'}
                    position="bottom right"
                    closeOnDocumentClick
                    repositionOnResize
                    keepTooltipInside={true}
                >
                    <div className="u_popover-more-text">
                        <div className="u_popover-more-text-inner">
                            {members?.slice(1).map((l, index) => {
                                return <div className={`u_flex-align ${members?.slice(1)?.length - 1 === index ? '' : 'u_mb-10'}`}>
                                    <UEmployeeInfo
                                        size={size ? size : 24}
                                        showName={false}
                                        employee={_USERS[l]}
                                        isSkeleton={!_USERS[l]}
                                    />
                                    <p className="u_pl-10 u_task-darkname u_small-font">{_USERS[l]?.name}</p>
                                </div>
                            })}
                        </div>
                    </div>
                </Popup>
            }
        </div>
    );
});

export default MembersFullNameList;
